import { useEffect } from "react";
import "./Table.css";

import Module from "../Module/Module";
import { linkifyText } from "../utils";

function Td(col) {

  console.log(col);
  
  //if(!col.text && !col.resources.length) return null;

  if (col.resources.length) {;
    return (
      <td className="module">
        {col.resources.map((resource, ind) => (
          <Module
            style={{ backgroundColor: "#ffffff" }}
            resource={resource}
            key={ind}
          />
        ))}
      </td>
    );
  } else {
    return (
      <td dangerouslySetInnerHTML={{__html:linkifyText(col.text)}}>
        
      </td>
    );
  }
}

function Table(props) {
  useEffect(() => {
    if (!props.plan?._id || !props.setPrint) return;
    props.setPrint(true);
  }, [props]);

  return (
    <div className="table-scroller">
      
      <table className={`preview-table ${props.className}`}>
        <>
          {props.showAll
            ? [ "Period", "Grade", "Subject", "Chapter", "Topic", "Sub Topic"].map(
                (key) => {
                  return (
                    <tr draggable={true} key={key}>
                      <th className={"extra-col"} key={key}>
                        {key}
                      </th>
                      <td className={"extra-col"} key={key}>
                        {props.extraValues[key]}
                      </td>
                    </tr>
                  );
                }
              )
            : null}
          {props.plan.cols.map((col, index) => {
            const td = Td(col);
            if (!td) return null;

            return (
              <tr key={index}>
                <th
                  className={col.colType === "resources" ? "module" : ""}
                  key={index}
                >
                  {col.colName}
                </th>
                {td}
              </tr>
            );
          })}
        </>
      </table>
    </div>
  );
}

export default Table;
